import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import PropTypes from "prop-types";
import * as geolib from "geolib";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Grid from "@material-ui/core/Grid/Grid";
import {ControlSlider, LatLngTextField, MiddleSliderWrapper} from "./Controls.sc";

const Controls = (props) => {

    const {
        boxSize, verticalScale, baseHeight, waterDrop, boxScale, lat, lng, handleBoxSizeChange,
        handleVerticalScaleChange, handleBaseHeightChange, handleWaterDropChange, handleBoxScaleChange,
        handleLocationChange, modelScale, handleModelScaleChange
    } = props;

    const latDiff = geolib.getDistance({latitude: lat, longitude: lng}, {
        latitude: lat + (boxSize * boxScale / 1200),
        longitude: lng
    });

    const lngDiff = geolib.getDistance({latitude: lat, longitude: lng}, {
        latitude: lat,
        longitude: lng + (boxSize * boxScale / 1200)
    });

    return (
        <Grid
            container
            spacing={0}
        >
            <Grid
                item
                xs={12}
                sm={6}
            >
                <div>
                    <Typography id="label">Box Size: {Number(lngDiff / 1000).toFixed(1)}km
                        x {Number(latDiff / 1000).toFixed(1)}km</Typography>
                    <ControlSlider
                        min={10}
                        max={1000}
                        step={10}
                        value={boxSize}
                        aria-labelledby="label"
                        onChange={(event, value) => handleBoxSizeChange(value)}
                    />
                </div>
                <MiddleSliderWrapper>
                    <Typography id="label">Box Scale (sampling rate): {boxScale}</Typography>
                    <ControlSlider
                        min={1}
                        max={5}
                        step={1}
                        value={boxScale}
                        aria-labelledby="label"
                        onChange={(event, value) => handleBoxScaleChange(value)}
                    />
                </MiddleSliderWrapper>
                <div>
                    <Tooltip
                        title="This parameters defines how the stl file is scaled. When set to 1, every point in the data set takes one square unit in the stl file."
                        placement="top">
                        <Typography id="label">Model Scale: {modelScale.toFixed(2)}</Typography>
                    </Tooltip>
                    <ControlSlider
                        min={0.01}
                        max={2}
                        step={0.01}
                        value={modelScale}
                        aria-labelledby="label"
                        onChange={(event, value) => handleModelScaleChange(value)}
                    />
                </div>
            </Grid>
            <Grid
                item
                xs={12}
                sm={6}
            >
                <div>
                    <Typography id="label">Vertical Scale Factor: {verticalScale.toFixed(1)}</Typography>
                    <ControlSlider
                        min={1}
                        max={10}
                        step={0.1}
                        value={verticalScale}
                        aria-labelledby="label"
                        onChange={(event, value) => handleVerticalScaleChange(value)}
                    />
                </div>
                <MiddleSliderWrapper>
                    <Typography id="label">Base Height: {baseHeight}mm</Typography>
                    <ControlSlider
                        min={1}
                        max={20}
                        step={1}
                        value={baseHeight}
                        aria-labelledby="label"
                        onChange={(event, value) => handleBaseHeightChange(value)}
                    />
                </MiddleSliderWrapper>
                <div>
                    <Tooltip
                        title="This parameters defines how the stl file is scaled. When set to 1, every point in the data set takes one square unit in the stl file."
                        placement="top">
                        <Typography id="label">Water Drop: {waterDrop}mm</Typography>
                    </Tooltip>
                    <ControlSlider
                        min={0}
                        max={9}
                        step={1}
                        value={waterDrop}
                        aria-labelledby="label"
                        onChange={(event, value) => handleWaterDropChange(value)}
                    />
                </div>
            </Grid>
            <Grid
                item
                xs={12}
            >
                <LatLngTextField
                    label="Latitude"
                    value={lat.toFixed(4)}
                    disabled={true}
                    onChange={(event) => handleLocationChange(Number(event.target.value), lng)}
                    margin="normal"
                    type="number"
                    inputProps={{min: -90, max: 90, step: 0.0001}}
                />
                <LatLngTextField
                    label="Longitude"
                    value={lng.toFixed(4)}
                    disabled={true}
                    onChange={(event) => handleLocationChange(lat, Number(event.target.value))}
                    margin="normal"
                    type="number"
                    inputProps={{min: -180, max: 180, step: 0.0001}}
                />
            </Grid>
        </Grid>
    );
};

Controls.propTypes = {
    boxSize: PropTypes.number.isRequired,
    verticalScale: PropTypes.number.isRequired,
    baseHeight: PropTypes.number.isRequired,
    waterDrop: PropTypes.number.isRequired,
    boxScale: PropTypes.number.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    modelScale: PropTypes.number.isRequired,

    handleBoxSizeChange: PropTypes.func.isRequired,
    handleVerticalScaleChange: PropTypes.func.isRequired,
    handleBaseHeightChange: PropTypes.func.isRequired,
    handleWaterDropChange: PropTypes.func.isRequired,
    handleBoxScaleChange: PropTypes.func.isRequired,
    handleLocationChange: PropTypes.func.isRequired,
    handleModelScaleChange: PropTypes.func.isRequired
};

export default Controls;



// WEBPACK FOOTER //
// ./src/common/Controls/Controls.js